import axios from "axios";
import Settings from "./config";
import { getApiEndpoint } from "./utilities";

export default {
  getConfiguration(cb) {
    axios.get("/umbraco/api/stay/getConfiguration").then((response) => {
      cb(response.data);
    });
  },

  async validateFields(payload, cb, fail) {
    var email =
      payload.leadGuest.emailAddress != null
        ? payload.leadGuest.emailAddress
        : "";
    var telephone =
      payload.leadGuest.telephone != null ? payload.leadGuest.telephone : "";

    if (email) {
      try {
        const emailResponse = await axios.post(
          `${Settings.WWWENDPOINT}/verifyEmail?email=${encodeURIComponent(
            email
          )}`
        );

        const emailResult = emailResponse.data;
        const invalidEmailStatuses = [
          "undeliverable",
          "illegitimate",
          "unreachable",
        ];
        if (invalidEmailStatuses.includes(emailResult)) {
          fail("Email is not valid.");
          return;
        }
      } catch (error) {
        fail("Email validation failed.");
        return;
      }
    }

    if (telephone) {
      try {
        const telResponse = await axios.post(
          `${Settings.WWWENDPOINT
          }/verifyTelephone?telephone=${encodeURIComponent(telephone)}`
        );
        const telResult = telResponse.data;
        const invalidTelephoneStatuses = ["unverified", "dead"];

        if (invalidTelephoneStatuses.includes(telResult)) {
          fail("Telephone is not valid.");
          return;
        }
      } catch (error) {
        fail("Telephone validation failed.");
        return;
      }
    }
    cb("valid");
  },

  search(sessionId, search, cb) {
    axios
      .post(
        getApiEndpoint() + "api/stay/" + sessionId + "/availability",
        search
      )
      .then((response) => {
        cb(response.data);
      });
  },
  fetchCalendar(sessionId, search, cb) {
    axios
      .post(
        getApiEndpoint() + "api/stay/" + sessionId + "/availability/calendar",
        search
      )
      .then((response) => {
        cb(response.data);
      });
  },
  fetchPackages(search, cb) {
    axios
      .post(getApiEndpoint() + "api/stay/packages", search)
      .then((response) => {
        cb(response.data);
      });
  },
  sendBooking(sessionId, booking, cb, fcb) {
    axios
      .post(getApiEndpoint() + "api/stay/" + sessionId + "/booking", booking)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        fcb(response);
      });
  },
  ignoreBooking(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/stay/ignore", payload)
      .then((response) => {
        cb(response.data);
      });
  },
  keepAlive(payload, cb, cbe) {
    axios
      .post(getApiEndpoint() + "api/stay/keep-alive", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        cbe(response.data);
      });
  },
  stageBooking(sessionId, booking, cb) {
    axios
      .post(
        getApiEndpoint() + "api/stay/" + sessionId + "/booking/stage",
        booking
      )
      .then((response) => {
        cb(response.data);
      });
  },

  completeBooking(sessionId, payment, cb, cbe) {
    axios
      .post(
        getApiEndpoint() + "api/stay/" + sessionId + "/booking/complete",
        payment
      )
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        cbe(response.data);
      });
  },

  fetchBookings(cb) {
    axios.get(getApiEndpoint() + "api/stay/user-bookings").then((response) => {
      cb(response.data);
    });
  },
  getBooking(id, cb) {
    axios
      .get(getApiEndpoint() + "api/stay/retrieve/" + id)
      .then((response) => {
        cb(response.data);
      });
  },
  cancelBooking(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/stay/cancel/", payload)
      .then((response) => {
        cb(response.data);
      });
  },
  removePackage(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/stay/remove-package/", payload)
      .then((response) => {
        cb(response.data);
      });
  },
  addPackage(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/stay/add-package/", payload)
      .then((response) => {
        cb(response.data);
      });
  },
  addDiningPackage(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/stay/add-dining-package/", payload)
      .then((response) => {
        cb(response.data);
      });
  },
  addSpaTreatmentPackage(payload, cb, fcg) {
    axios
      .post(getApiEndpoint() + "api/stay/add-spa-treatment-package/", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        fcb(response);
      });
  },

  addSpaGardenPackage(payload, cb, fcg) {
    axios
      .post(getApiEndpoint() + "api/stay/add-spa-garden-package/", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        fcb(response);
      });
  },

  addSpaMudPackage(payload, cb, fcg) {
    axios
      .post(getApiEndpoint() + "api/stay/add-spa-mud-package/", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        fcb(response);
      });
  },

  sendEmail(payload, cb, fcb) {
    axios
      .post(getApiEndpoint() + "api/stay/send-email/", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        fcb();
      });
  },
};
